'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUploadProgress = exports.setFileId = exports.setFile = undefined;

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _fileUploadKeyPaths = require('../constants/fileUploadKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setFile = exports.setFile = (0, _setIn2.default)(_fileUploadKeyPaths.FILE);

var setFileId = exports.setFileId = (0, _setIn2.default)(_fileUploadKeyPaths.FILE_ID);

var setUploadProgress = exports.setUploadProgress = (0, _setIn2.default)(_fileUploadKeyPaths.UPLOAD_PROGRESS);